import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import Meun from '../meun'
import s from './Header.module.scss'

// 产品白名单列表
const PRODUCT_WHITELIST = new Set([
  'lee-guitars-thermo-hygrometer',
  'temp-rh-monitor-lite',
  'temp-rh-monitor-3',
  'temp-rh-monitor-lite-3',
  'temp-rh-monitor-pro-s',
  'co2-temp-rh-monitor',
  'wall-socket-thermometer',
  'temp-rh-monitor-pro-e',
  'air-monitor',
  'air-monitor-2',
  'air-monitor-lite',
  'door-window-sensor',
  'motion-light-sensor',
  'bluetooth-gateway',
  'bluetooth-alarm-clock',
  'bluetooth-clock',
]);

// 平台路径列表
const PLATFORM_PATHS = [
  '/plus',
  '/lee-guitars/app',
  '/iot',
  '/air',
  '/apps/qingpingplus'
];

// 普通路径列表（不显示二级导航）
const COMMON_PATHS = [
  '/',
  '/contact',
  '/store',
  '/privacy',
  '/about-us',
  '/eu-declarations'
];

// 标题映射表
const TITLE_MAP = {
  'wall-socket-thermometer': 'gecko_name',
  'co2-temp-rh-monitor': 'ph_co2_name_value',
  'temp-rh-monitor': 'goose_lite',
  'temp-rh-monitor-3': 'goose3_lite',
  'temp-rh-monitor-lite': 'duck2',
  'temp-rh-monitor-lite-3': 'duck3',
  'lee-guitars-thermo-hygrometer': 'magpie',
  'temp-rh-monitor-pro-s': 'pheasant',
  'temp-rh-monitor-pro-e': 'frog',
  'mi-temp-rh-monitor': null, // 直接使用文本值
  'air-monitor': 'snow',
  'air-monitor-2': 'sw2',
  'air-monitor-lite': 'dany_name',
  'door-window-sensor': 'hodor_name',
  'motion-light-sensor': 'parrot_name',
  'bluetooth-clock': 'chicken',
  'plus': 'cg_app',
  'lee-guitars': 'cg_magpie',
  'air': 'cg_app',
  'iot': 'qing_ping_iot_m',
  'bluetooth-gateway': 'sparrow',
  'bluetooth-alarm-clock': 'dove',
};

// 防止事件默认行为的处理函数
const preHandler = (e) => {
  e.preventDefault();
};

// Header组件
function Header(props) {
  // 解构props
  const {
    locale = '',
    location = {},
    path = '',
    hideSecondSub,
    hideSecondSubFunc,
    headerShow
  } = props;

  // 组件状态
  const [state, setState] = useState({
    language: null,
    display: false,
    ios: true,
    toBrowser: s.toBrowser,
    purchaseHide: true,
    hideGooseChoice: true,
    hideGooseChoiceArrow: true,
    hideGooseChoiceBtn: true,
  });

  // 获取和处理路径信息
  const pathArr = path ? path.split('/') : [''];
  const pathFirstSegment = pathArr[1] || '';
  const pathSecondSegment = pathArr[2] || '';
  const isPlatformPath = PLATFORM_PATHS.includes(path);
  const isCommonPath = COMMON_PATHS.includes(path);
  const isSpecialPath = path === '/temp-rh-monitor-pro-s' || path === '/temp-rh-monitor-pro-e' || path === '/bluetooth-alarm-clock/apps';

  // 处理菜单显示状态
  const toggleMenu = useCallback((e, level) => {
    e.stopPropagation();
    e.persist();
    
    if (level === 3) {
      hideSecondSubFunc && hideSecondSubFunc(!hideSecondSub, e);
    } else {
      setState(prev => ({
        ...prev,
        display: !prev.display
      }));
    }
  }, [hideSecondSub, hideSecondSubFunc]);

  // 处理点击外部关闭弹窗
  const handleClickOutside = useCallback((event) => {
    const eName = event.target.getAttribute('name');
    
    if (eName === 'shopArrow') {
      setState(prev => ({
        ...prev,
        hideGooseChoice: !prev.hideGooseChoice,
        hideGooseChoiceArrow: !prev.hideGooseChoice,
        hideGooseChoiceBtn: true,
      }));
    } else if (eName === 'gooseBuy') {
      setState(prev => ({
        ...prev,
        hideGooseChoice: !prev.hideGooseChoice,
        hideGooseChoiceArrow: true,
        hideGooseChoiceBtn: !prev.hideGooseChoice,
      }));
    } else {
      setState(prev => ({
        ...prev,
        hideGooseChoice: true,
        hideGooseChoiceArrow: true,
        hideGooseChoiceBtn: true,
      }));
    }
  }, []);

  // 处理商品链接数据加载完成
  const handleGoodLinksLoaded = useCallback(() => {
    // 强制更新组件
    setState(prev => ({ ...prev }));
  }, []);

  // 处理页面溢出控制
  const setOverflow = useCallback(() => {
    const html = document.getElementsByTagName('html')[0];
    
    if (state.display) {
      if (state.ios) {
        html.style.position = 'fixed';
      }
      html.style.overflow = 'hidden';
      html.style.height = '100%';
      html.style.width = '100%';
      document.addEventListener('touchmove', preHandler, false);
    } else {
      html.style.overflow = 'auto';
      html.style.position = 'initial';
      html.style.height = 'auto';
      document.removeEventListener('touchmove', preHandler, false);
    }
  }, [state.display, state.ios]);

  // 显示购买选项弹窗
  const purchaseClick = useCallback((e) => {
    e.stopPropagation();
    setState(prev => ({
      ...prev,
      purchaseHide: !prev.purchaseHide
    }));
  }, []);

  // 显示浏览器提示
  const handleShowPhone = useCallback(() => {
    setState(prev => ({
      ...prev,
      toBrowser: s.toBrowserShow
    }));
  }, []);

  // 监听菜单显示状态变化，控制页面溢出
  useEffect(() => {
    setOverflow();
  }, [state.display, setOverflow]);

  // 组件挂载后初始化
  useEffect(() => {
    // 设置语言
    let browserLanguage = navigator.browserLanguage || navigator.language;
    
    switch (browserLanguage) {
      case 'en':
        browserLanguage = 'en-US';
        break;
      case 'zh':
        browserLanguage = 'zh-CN';
        break;
      default:
        browserLanguage = 'en-US';
    }
    
    setState(prev => ({
      ...prev,
      language: browserLanguage
    }));
    
    // 添加事件监听
    document.addEventListener('click', handleClickOutside, true);
    window.addEventListener('goodLinksLoaded', handleGoodLinksLoaded);
    
    // 组件卸载时移除事件监听
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      window.removeEventListener('goodLinksLoaded', handleGoodLinksLoaded);
    };
  }, [handleClickOutside, handleGoodLinksLoaded]);

  // 计算各种样式类名
  const getStyles = () => {
    // 基础样式
    let styles = {
      header: headerShow === false ? s.noDisplay : s.header,
      secondSubName: s.secondSub,
      meunName: state.display ? s.IconCur : s.Icon,
      sName: s.hide,
      arrowName: s.arrow,
      purchaseName: state.purchaseHide ? s.purchaseHide : s.purchaseShow,
      thirdCur: [null, null]
    };

    // 更新二级菜单样式
    if (!hideSecondSub) {
      styles.sName = s.show;
      styles.arrowName = s.arrowCur;
    }

    // 特殊路径处理
    if (isSpecialPath) {
      if (path === '/bluetooth-alarm-clock/apps') {
        styles.secondSubName = s.noDisplay;
        styles.arrowName = s.noDisplay;
        styles.meunName = s.noDisplay;
      } else {
        styles.sName = s.noDisplay;
        styles.arrowName = s.noDisplay;
      }
    } else if (isPlatformPath) {
      styles.sName = s.noDisplay;
      styles.arrowName = s.noDisplay;
    } else if (isCommonPath) {
      styles.secondSubName = s.noDisplay;
      styles.arrowName = s.noDisplay;
    }

    // 小米产品特殊处理
    if (pathFirstSegment === 'mi-temp-rh-monitor' || pathFirstSegment === 'mi-multifunction-air-monitor') {
      styles.secondSubName = s.noDisplay;
    }

    // 规格页面激活状态
    if (pathSecondSegment === 'specifications') {
      styles.thirdCur[1] = s.active;
    } else {
      styles.thirdCur[0] = s.active;
    }

    return styles;
  };

  // 获取产品标题
  const getProductTitle = () => {
    const titleId = TITLE_MAP[pathFirstSegment];
    
    if (pathFirstSegment === 'mi-temp-rh-monitor') {
      return '小米米家蓝牙温湿度计';
    }
    
    if (titleId) {
      const needValues = ['magpie', 'frog', 'hodor_name', 'parrot_name', 'chicken'];
      return needValues.includes(titleId) ? 
        <FormattedMessage id={titleId} values={{ br: '' }} /> : 
        <FormattedMessage id={titleId} />;
    }
    
    return <FormattedMessage id="goose_lite" />;
  };

  // 计算跳转URL
  const getNavigationUrl = () => {
    let url = 'temp-rh-monitor';
    
    if (PRODUCT_WHITELIST.has(pathFirstSegment)) {
      url = pathFirstSegment;
    }
    
    return url;
  };

  // 获取商品数据
  const getGoodsData = () => {
    const goodLinksOrigin = localStorage.getItem('goodLinks');
    const goodsLink = goodLinksOrigin ? JSON.parse(goodLinksOrigin) : [];
    const goodsShops = goodsLink[pathFirstSegment]?.shops || [];
    const isSoldOut = goodsLink[pathFirstSegment]?.status === 'off' || false;
    
    let getJumpLink = goodsShops?.filter(item => item.tag) || [];
    
    const ifUs = locale.indexOf('US') > -1;
    if (pathFirstSegment === 'motion-light-sensor') {
      getJumpLink = ifUs 
        ? getJumpLink.filter(item => item.name_key.startsWith('t_')) 
        : getJumpLink.filter(item => item.name_key.startsWith('m_'));
    }
    if(pathFirstSegment === 'temp-rh-monitor' ){
      getJumpLink =  getJumpLink.filter(item => item.name_key.startsWith('t_')) 
    }
    
    return {
      goodLinksOrigin,
      goodsShops,
      isSoldOut,
      getJumpLink
    };
  };

  // 渲染购买按钮
  const renderBuyButton = () => {
    const { goodLinksOrigin, goodsShops, isSoldOut, getJumpLink } = getGoodsData();
    
    if (isSoldOut || !goodLinksOrigin) {
      return (
        <div className={s.secondBuy} style={{ backgroundColor: '#ccc' }}>
          <div className={s.buy_a}>
            <span
              style={{
                display: "block",
                width: "100%",
                textAlign: "center",
                paddingLeft: 0.5,
              }}
            >
              {locale.indexOf("US") > -1
                ? "Buy"
                : locale.indexOf("TW") > -1
                ? "購買"
                : "购买"}
            </span>
          </div>
        </div>
      );
    } 
    
    if (getJumpLink && getJumpLink.length) {
      return (
        <div className={s.secondBuy}>
          <a
            className={s.buy_a}
            href={getJumpLink[0].link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="buy" />
          </a>
        </div>
      );
    }
    
    return (
      <div
        className={!state.hideGooseChoiceBtn ? s.gooseSecondBuy : s.secondBuy}
      >
        <div className={s.buy_a}>
          <span
            name="gooseBuy"
            style={{
              display: "block",
              width: "100%",
              textAlign: "center",
              paddingLeft: 0.5,
            }}
          >
            {locale.indexOf("US") > -1
              ? "Buy"
              : locale.indexOf("TW") > -1
              ? "購買"
              : "购买"}
          </span>
        </div>
      </div>
    );
  };

  // 渲染购买选项弹窗
  const renderBuyOptions = () => {
    const { goodsShops, isSoldOut } = getGoodsData();
    
    if (goodsShops?.length > 0 && !state.hideGooseChoice && !isSoldOut) {
      return (
        <div className={s.buyBox}>
          {goodsShops.map((item) => (
            <div className={s.buyItem} key={item.name_key}>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage id={item.name_key} />
              </a>
            </div>
          ))}
        </div>
      );
    }
    
    return null;
  };

  // 样式、URL和标题数据
  const styles = getStyles();
  const url = getNavigationUrl();
  const title = getProductTitle();
  const { goodsShops, isSoldOut } = getGoodsData();

  // 渲染组件
  return (
    <div className={styles.header}>
      {/* 菜单按钮 */}
      <div className={styles.meunName} onClick={(e) => toggleMenu(e, 2)}>
        <i className={s.meun_1} />
        <i className={s.meun_2} />
        <i className={s.meun_1} />
      </div>
      
      {/* Logo */}
      <div className={s.logo}>
        <a href="/">
          <i />
        </a>
      </div>
      
      {/* 导航菜单 */}
      <div className={s.nav}>
        {/* 主菜单 */}
        <Meun
          path={path}
          location={location}
          display={state.display}
          callback={() => setState(prev => ({ ...prev, display: false }))}
        />
        
        {/* 二级菜单 */}
        <div className={styles.secondSubName}>
          {/* 标题栏 */}
          <div className={s.title} name="secondSub" onClick={(e) => toggleMenu(e, 3)}>
            {title}
            <div className={styles.arrowName} />
          </div>

          {/* 非平台页面内容 */}
          {!isPlatformPath && (
            <>
              {/* 购买按钮区域 */}
              <div className={s.secondBuyRightBox}>
                {renderBuyButton()}
                
                {/* 显示购买选项箭头 */}
                {(goodsShops?.length > 0 && !isSoldOut) && (
                  <div 
                    name="shopArrow" 
                    className={[
                      s.shopArrow,
                      !state.hideGooseChoiceArrow ? s.arrowCur : ''
                    ].join(' ')} 
                  />
                )}
              </div>
              
              {/* 购买选项弹窗 */}
              {renderBuyOptions()}

              {/* 导航链接 */}
              <ul className={styles.sName}>
                <li></li>
                <li className={styles.thirdCur[0]}>
                  <Link
                    name="secondSub"
                    onClick={(e) => toggleMenu(e, 3)}
                    to={`/${url}/overview`}
                  >
                    <FormattedMessage id="overview" />
                  </Link>
                </li>
                <li className={styles.thirdCur[1]}>
                  <Link
                    name="secondSub"
                    onClick={(e) => toggleMenu(e, 3)}
                    to={`/${url}/specifications`}
                  >
                    <FormattedMessage id="specifications" />
                  </Link>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
      
      {/* 浏览器提示 */}
      <div className={state.toBrowser}>
        <div className={s.arrow} />
        <div className={s.toBrowserText}>
          1. 点击右上角&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <br />
          2. 在菜单中选择 <span>"浏览器中打开"</span>
        </div>
        <div className={s.toBrowserPhone} />
      </div>
      
      {/* 采购信息 */}
      <div className={styles.purchaseName}>
        <span>
          请发送邮件至{' '}
          <a
            href="mailto:bd@qingping.co"
            target="_blank"
            rel="noopener noreferrer"
          >
            bd@qingping.co
          </a>
          ，<br />
          或致电李先生 <a href="tel:18911877866">189 1187 7866</a> 获取报价。
        </span>
        <i onClick={purchaseClick} />
      </div>
    </div>
  );
}

// Redux连接
const mapStateToProps = (state) => ({
  locale: state.language,
});

export default connect(mapStateToProps)(Header);
